/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import {
  PrismicPreviewProvider,
  componentResolverFromMap,
} from 'gatsby-plugin-prismic-previews';

import { linkResolver } from './src/utils/linkResolver';
import PageTemplate from './src/templates/pageTemplate';
import NewsTemplate from './src/templates/newsTemplate';
import EventTemplate from './src/templates/eventTemplate';

export const wrapRootElement = ({ element }) => (
  <PrismicPreviewProvider
    repositoryConfigs={[
      {
        repositoryName: process.env.GATSBY_PRISMIC_REPO_NAME,
        linkResolver,
        componentResolver: componentResolverFromMap({
          page: PageTemplate,
          news: NewsTemplate,
          event: EventTemplate,
        }),
      },
    ]}
  >
    {element}
  </PrismicPreviewProvider>
);

async function loadPolyfills() {
  if (typeof window.IntersectionObserver === 'undefined') {
    await import('intersection-observer');
  }
}
loadPolyfills();
